<template>
  <div
    class="uiNotice bg-white"
    :class="{ 'priority': priority }"
    @click="click"
  >
    <div class="uiNotice__label">
      {{ label }}
    </div>

    <div
      v-if="body"
      class="uiNotice__body"
    >
      {{ body }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'UiNotice',
  props: {
    label: {
      type: String,
      required: true,
    },

    body: {
      type: String,
      default() {
        return null;
      },
    },

    to: {
      type: [String, Object],
      default() {
        return null;
      },
    },

    priority: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },

  methods: {
    click() {
      if (this.to) {
        this.$router.push(this.to);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.uiNotice {
  border-radius: $generic-border-radius;
  padding: 16px 20px;
  filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.1));

  &__label {
    color: $primary;
    font-size: 14px;
    font-weight: 600;
  }

  &__body {
    font-size: 16px;
    font-weight: 600;
  }

  &.priority {
    .uiNotice__label {
      color: $negative;
      text-align: center;
      text-transform: uppercase;
    }
  }
}
</style>
